module.exports = __webpack_public_path__ + "static/media/IMG_3497_sm.3027545f.jpg";